import { getRouter } from '@app/utils/routing/Context'

import { profileUserIdSelector } from '@app/store/selectors/profile'
import { createThunk } from '@app/store/thunk'

import { assertMountPush } from '@app/components/Mount/actions'

import { getApplicationBridge } from './contexts/applicationBridge'

/**
 * Opens support chat. Inside the app's webview support is handed to the native app; anyone with
 * an account, a visitor too, gets the support dialog in messages; only a guest gets the widget.
 */
export const showSupportChatModal = (onClose?: () => void) =>
  createThunk((dispatch, getState) => {
    const appBridge = dispatch(getApplicationBridge())
    if (appBridge && appBridge.matchVersion('3.40.0') >= 0) {
      appBridge.sendMessage({ type: 'open_sitter_support_chat' })
      appBridge.sendMessage({ type: 'open_support_chat' })
      return
    }

    if (profileUserIdSelector(getState())) {
      dispatch(getRouter()).history.push('/m/support')
      onClose?.()
      return
    }

    void dispatch(
      assertMountPush(
        import('@app/components/SupportChatWidgetModal/SupportChatWidgetModal').then(m => m.SupportChatWidgetModal),
        { onClose }
      )
    )
  })
